import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Activitats from '../../jutge/problemes/content/Activitats';

export const GameActivitiesModal: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Solo accesible si está dentro de un iframe (el juego)
        const isInsideIframe = window.self !== window.top;
        if (!isInsideIframe) {
            navigate('/home', { replace: true });
        }
    }, [navigate]);

    return (
        <div style={{
            background: '#f8f9fb',
            minHeight: '100vh',
            padding: '16px 20px',
            overflowY: 'auto'
        }}>
            <Activitats isGameModal={true} />
        </div>
    );
};

export default GameActivitiesModal;
